import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input } from '@angular/core';

import { SnShare } from '@lib/api/entities';
import { snListStagger, snFadeIn, snFadeOut } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';

@Component({
  selector: 'sn-share-table',
  templateUrl: './share-table.component.html',
  styleUrls: ['./share-table.component.scss'],
  animations: [snListStagger, snFadeIn, snFadeOut],
})
export class ShareTableComponent extends SnTableBaseComponent<SnShare> {
  @Input()
  public selection: SelectionModel<SnShare>;

  constructor() {
    super();
  }

  public trackBy(index: number, item: SnShare): string {
    return item.id;
  }

  public masterToggle(): void {
    this.isAllSelected() ? this.selection.clear() : this.selection.select(...this.items);
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.items.length;

    return numSelected === numRows;
  }
}
